"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.uniqueAttachmentList = uniqueAttachmentList;
function uniqueAttachmentList(list) {
    const map = new Map();
    for (const item of list) {
        map.set(`${item.timestamp}|${item.filename}`, item);
    }
    return Array.from(map.values());
}
